import { render, staticRenderFns } from "./SpinnerWheelTable.vue?vue&type=template&id=dcf02c2a&scoped=true"
import script from "./SpinnerWheelTable.vue?vue&type=script&lang=js"
export * from "./SpinnerWheelTable.vue?vue&type=script&lang=js"
import style0 from "./SpinnerWheelTable.vue?vue&type=style&index=0&id=dcf02c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf02c2a",
  null
  
)

export default component.exports